"use client";
import { cn as e } from "../../design/cn.js";
import { PaginationNextTrigger as t, PaginationPages as n, PaginationPrevTrigger as r, PaginationRoot as i } from "../../design/pagination/Pagination.js";
import { Button as a } from "../../design/button/index.js";
import { InputText as o } from "../../design/forms/input-text/index.js";
import { Select as s } from "../../design/forms/select/index.js";
import * as c from "react";
import { Fragment as l, jsx as u, jsxs as d } from "react/jsx-runtime";
// src/components/data-table/DataTablePagination.tsx
var f = [
	10,
	20,
	50,
	100
], p = ({ page: t, totalPages: n, onGo: r, className: i, inputClassName: a }) => {
	let [s, l] = c.useState(""), f = () => {
		let e = Math.round(Number(s));
		l(""), Number.isFinite(e) && e >= 1 && e <= n && e !== t && r(e);
	};
	return /* @__PURE__ */ d("div", {
		className: e("flex items-center gap-2 text-xs text-muted-foreground min-w-35", i),
		children: [
			/* @__PURE__ */ u("span", { children: "Go to" }),
			/* @__PURE__ */ u(o, {
				value: s,
				placeholder: String(t),
				"aria-label": "Go to page",
				inputMode: "numeric",
				config: { size: "sm" },
				rootClassName: "w-max h-7",
				className: e("w-10 h-7 p-1", a),
				onChange: (e) => l(e.target.value.replace(/\D/g, "")),
				onKeyDown: (e) => {
					e.key === "Enter" && f();
				},
				onBlur: f
			}),
			/* @__PURE__ */ d("span", {
				className: "",
				children: ["/ ", n.toLocaleString()]
			})
		]
	});
}, m = ({ config: o, totalItems: m, currentPage: h, resolvedPageSize: g, isClient: _, setPagination: v, density: y = "compact", className: b }) => {
	let x = (o.density ?? y) === "compact", S = o.size ?? (x ? "sm" : "md"), C = o.variant ?? "compact", w = x ? "xs" : "sm", T = o.classNames ?? {}, E = o.showInfo ?? !0, D = o.showPageSize ?? !0, O = o.showGoTo ?? !0, k = o.showFirstLast ?? !1, A = c.useMemo(() => {
		let e = o.pageSizeOptions ?? f;
		return e.includes(g) ? e : [...e, g].toSorted((e, t) => e - t);
	}, [o.pageSizeOptions, g]);
	if (o.show === !1) return null;
	let j = (e) => {
		_ ? v((t) => ({
			...t,
			pageIndex: Math.max(0, e - 1)
		})) : o.onPageChange?.(e - 1);
	}, M = (e) => {
		_ ? v((t) => ({
			...t,
			pageSize: e,
			pageIndex: 0
		})) : o.onPageSizeChange?.(e);
	}, N = m === 0 ? 0 : (h - 1) * g + 1, P = Math.min(m, h * g), F = "text-foreground";
	return /* @__PURE__ */ d("footer", {
		className: e("flex flex-wrap items-center justify-between gap-x-4 gap-y-2 border-t border-border bg-back", x ? "px-2 py-1" : "px-3 py-1.5", o.className, T.root, b),
		children: [/* @__PURE__ */ d("div", {
			className: e("flex flex-wrap items-center gap-x-4 gap-y-2 text-xs whitespace-nowrap text-muted-foreground", T.info),
			children: [D && /* @__PURE__ */ d("div", {
				className: e("flex items-center gap-2", T.pageSize),
				children: [/* @__PURE__ */ u("span", { children: "Rows per page" }), /* @__PURE__ */ u("div", {
					className: e(x ? "w-20" : "w-24", T.pageSizeSelect),
					children: /* @__PURE__ */ u(s, {
						className: e(T.pageSizeTrigger, "h-6"),
						"aria-label": "Rows per page",
						options: A.map((e) => ({
							label: String(e),
							value: String(e)
						})),
						value: String(g),
						onChange: (e) => {
							e.value && !Array.isArray(e.value) && M(Number(e.value.value));
						},
						showClearButton: !1,
						searchable: !1
					})
				})]
			}), E && /* @__PURE__ */ d("span", {
				className: T.range,
				children: [
					/* @__PURE__ */ d("span", {
						className: F,
						children: [
							N.toLocaleString(),
							"–",
							P.toLocaleString()
						]
					}),
					" ",
					"of ",
					/* @__PURE__ */ u("span", {
						className: F,
						children: m.toLocaleString()
					})
				]
			})]
		}), /* @__PURE__ */ u(i, {
			count: m,
			pageSize: g,
			page: h,
			siblingCount: o.siblingCount,
			variant: C,
			size: S,
			className: "justify-end gap-4",
			onPageChange: ({ page: e }) => j(e),
			children: (i) => /* @__PURE__ */ d(l, { children: [/* @__PURE__ */ d("div", {
				className: e("flex items-center", x ? "gap-1" : "gap-1.5", T.pages),
				children: [
					k && /* @__PURE__ */ u(a.IconButton, {
						icon: "ChevronsLeft",
						variant: "ghost",
						size: w,
						className: T.iconButton,
						"aria-label": "First page",
						disabled: i.page <= 1,
						onClick: () => i.setPage(1)
					}),
					/* @__PURE__ */ u(r, {}),
					/* @__PURE__ */ u(n, { size: "sm" }),
					/* @__PURE__ */ u(t, {}),
					k && /* @__PURE__ */ u(a.IconButton, {
						icon: "ChevronsRight",
						variant: "ghost",
						size: w,
						className: T.iconButton,
						"aria-label": "Last page",
						disabled: i.page >= i.totalPages,
						onClick: () => i.setPage(i.totalPages)
					})
				]
			}), O && /* @__PURE__ */ u(p, {
				page: i.page,
				totalPages: i.totalPages,
				onGo: i.setPage,
				className: T.goTo,
				inputClassName: T.goToInput
			})] })
		})]
	});
};
m.displayName = "DataTablePagination";
export { m as DataTablePagination };

//# sourceMappingURL=DataTablePagination.js.map